import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-installments-box" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_summary_list = _resolveComponent("base-summary-list")
  const _component_base_notificator = _resolveComponent("base-notificator")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_themed_image, {
        src: "/content/images/static/stretch-pay/installments-logo.svg",
        alt: "stretchPay",
        width: "91"
      })
    ]),
    _createVNode(_component_base_summary_list, {
      "summary-list-data": $options.installmentsInfo,
      size: "large"
    }, {
      description: _withCtx(() => [
        _createElementVNode("p", {
          class: "_tc--dark _my-0",
          innerHTML: $options.installmentCountText
        }, null, 8 /* PROPS */, _hoisted_2)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["summary-list-data"]),
    ($props.isNotificatorVisible)
      ? (_openBlock(), _createBlock(_component_base_notificator, {
          key: 0,
          "can-close": false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.InstallmentCollectionText), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "content")
  ]))
}